import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { GestionTILayout } from "./GestionTILayout";
import { GestionTIScreen } from "./GestionTIScreen";
import { NuevaSolicitudScreen } from "./NuevaSolicitudScreen";

export const GestionTIMainScreen = () => {
    return (
        <GestionTILayout>
            <Switch>
                <Route path="/GestionTI/Principal" component={GestionTIScreen} />
                <Route path="/GestionTI/NuevaSolicitud" component={NuevaSolicitudScreen} />
                <Redirect to="/GestionTI/Principal" />
            </Switch>
        </GestionTILayout>
    );
};
